(function() {
    angular.module('tmx-app').controller('guarantorSummaryCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'BranchService',
        'GuarantorSummaryService',

        function guarantorSummaryCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            BranchService,
            GuarantorSummaryService
        ) {
            var guarantorSummaryVM = this;
            guarantorSummaryVM.menu = menu;
            guarantorSummaryVM.gridData = new kendo.data.ObservableArray([]);
    // guarantorSummaryVM.checkPermission = PrivilegesService.checkPermission;
            guarantorSummaryVM.search = search;
            guarantorSummaryVM.filterEnabled = false;
    // guarantorSummaryVM.disableExport = true;
            guarantorSummaryVM.toggle = toggle;
            guarantorSummaryVM.isOpen = isOpen;
            var exportLoanApplicationNumber = null;
            var exportCulture=null;
    // var exportBranchId = null;
    // var exportNationalId=null;
            guarantorSummaryVM.clear = clear;
            guarantorSummaryVM.formatColumnName = tmxUtility.formatColumnName;
            guarantorSummaryVM.culture = (localStorage.getItem("culture"));


            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }
            function clear() {
    //   guarantorSummaryVM.disableExport = true;
                guarantorSummaryVM.LoanApplicationNumber = null;
      // guarantorSummaryVM.BranchId=null;
      // guarantorSummaryVM.NationalId=null;
                guarantorSummaryVM.container.guarantorSummaryGrid.dataSource.read();
            }

      
            BranchService.getByAction('',true).then(function(response){
                decorateForSelect(response.data);
                guarantorSummaryVM.Branches=response.data;
            });

            function decorateForSelect(arrayOfObj) {
                arrayOfObj.forEach(
                    function (obj) {
                        obj.LookupId=obj.CompanyBranchId;
                        obj.VisibleValue = obj.BranchName;
                        obj.HiddenValue = obj.BranchCode;
                    }
                );
            }

            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            guarantorSummaryVM.exportToPdf = exportToPdf;

            function search() {
                guarantorSummaryVM.container.guarantorSummaryGrid.dataSource.read();
                guarantorSummaryVM.filterEnabled = true;
                exportLoanApplicationNumber = angular.copy(guarantorSummaryVM.LoanApplicationNumber);
                exportCulture=angular.copy(guarantorSummaryVM.culture);
      // exportBranchId=angular.copy(guarantorSummaryVM.BranchId);
      // exportNationalId=angular.copy(guarantorSummaryVM.NationalId);
            }

            function exportToPdf() {
                var loanapplicationnumber = exportLoanApplicationNumber
                    ? exportLoanApplicationNumber
                    : null;
                var culture = exportCulture 
                    ?  exportCulture :
                    null;
                GuarantorSummaryService.exportGuarantorSummary(loanapplicationnumber,culture);
            }

            guarantorSummaryVM.formatlabel=function(data){
      // console.log(data);
                if(data)
                    return data
                        .replace(/_/g, " ");
                else return data;
            }

            guarantorSummaryVM.formatLabelItem =function(item){
                if(!angular.isDefined(item) || item==null || item.toString().trim()==""){
                    return 'N/A';
                }
                return item.replace(/_/g, ' ');
            }

            guarantorSummaryVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            var loanapplicationnumber = null;
                            var culture = null;
            // var branchid=null;
            // var nationalid=null;

                            if (
                                angular.isUndefined(guarantorSummaryVM.LoanApplicationNumber) ||
              (guarantorSummaryVM.LoanApplicationNumber == "" ||
                guarantorSummaryVM.LoanApplicationNumber == 0)
                            ) {
                                loanapplicationnumber = 0;
                            }
                            else {
                                loanapplicationnumber = guarantorSummaryVM.LoanApplicationNumber
                                    ? guarantorSummaryVM.LoanApplicationNumber
                                    : null;
                            }
                            if (
                                angular.isUndefined(guarantorSummaryVM.culture) ||
              (guarantorSummaryVM.culture == "" )
                            ) {
                                culture = null;
                            }
                            else {
                                culture = guarantorSummaryVM.culture
                                    ? guarantorSummaryVM.culture
                                    : null;
                            }
                            var objArgs = {
                                LoanApplicationNumber:loanapplicationnumber,
                                culture:culture
                            };
  
                            var filters = {
                                StoredProcedure: "sp_guarantor_summary",
                                Arguments: objArgs,
                                ReportName: "Guarantor_Summary"
                            };

                            var jsonString = JSON.stringify(filters)
                                .replace(/:/g, "~")
                                .replace(/,/g, "^");

                            guarantorSummaryVM.o = angular.copy(o);
                            guarantorSummaryVM.filters = guarantorSummaryVM.o.data.filter;
                            firebase.logTmxEvent('report',{name:'Guarantor Summary Report'});
                            GuarantorSummaryService.getByParams(o,true, "/ReportDataSourceResult/" + jsonString).then(function(response) {
                                o.success(response);
                                guarantorSummaryVM.filterEnabled = true;
                            });
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
          // parse: function(response) {
          //   if (response != undefined) {
          //     response = response.data;

          //     var invoices = [];
          //     var invoiceNumber = [];

          //     for (var i = 0; i < response.length; i++) {
          //       var invoice = response[i];

          //       invoice.InvoiceGroup =
          //         invoice.InvoiceGroup +
          //         " -- Date:" +
          //         moment(invoice.InvoiceDate).format("DD/MM/YYYY") +
          //         " -- Customer: " +
          //         invoice.CustomerName +
          //         " -- Status: " +
          //         invoice.ClubbedStatus;
          //       invoice.InvoiceDate = moment(invoice.InvoiceDate).format(
          //         "DD-MM-YYYY"
          //       );

          //       if (!invoiceNumber.includes(invoice.InvoiceNumber)) {
          //         invoices.push(invoice);
          //         invoiceNumber.push(invoice.InvoiceNumber);
          //       }
          //     }


          //     invoices = {
          //       data: invoices
          //     };

          //     return invoices;
          //   }
          // }
                    },
        // aggregate: [
        //   { field: "InvoiceNumber", aggregate: "count" },
        //   { field: "InvoiceLineTax", aggregate: "count" },
        //   { field: "InvoiceTotalAmount", aggregate: "sum" }
        // ],
        // group: {
        //   field: "InvoiceNumber",
        //   aggregates: [
        //     { field: "InvoiceNumber", aggregate: "count" },
        //     { field: "InvoiceLineTax", aggregate: "count" },
        //     { field: "InvoiceTotalAmount", aggregate: "sum" }
        //   ]
        // },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
        // sort: [{ field: "InvoiceDate", dir: "desc" }]
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 15,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "GuarantorSummary.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {


                        var row = sheet.rows[rowIndex];
                        row.cells[0].value = guarantorSummaryVM.formatLabelItem(row.cells[0].value);

                    }
                    columns.forEach(function(column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: GuarantorSummaryService.GridColumns
            };
        }]);
})();
